import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import TextInfo, {
  KIND_TEXT,
  COLOR,
  SIZE,
  FONT_TYPE,
} from '@bit/gerenciatd.unifiedcomponents.text-info';
import './Legals.scss';

const Legals = ({ selectedProduct }) => {
  const legalInfo = selectedProduct.product.commerInfo.find(eachCommerInfo => eachCommerInfo.alias.includes('ic_legales'));

  return (
    <Fragment>
      {legalInfo.commerInfo
        && legalInfo.commerInfo.map((item) => {
          return (
            <div className="productConditions">
              <TextInfo
                text={item.title}
                color={COLOR.GREY_5}
                size={SIZE.TITLE2}
                fontType={FONT_TYPE.LIGHT}
                kind={KIND_TEXT.SPAN}
                className="legal-title"
              />
              <TextInfo
                text={item.summary}
                color={COLOR.GREY_5}
                size={SIZE.caption03}
                fontType={FONT_TYPE.LIGHT}
                kind={KIND_TEXT.PARAGRAPH}
              />
            </div>
          );
        })}
    </Fragment>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

const mapStateToProps = state => ({
  reduxFilters: state.filters.filters,
  device: state.context.data.device,
});

export default connect(mapStateToProps, mapDispatchToProps)(Legals);
